<template>
  <div>
    <header-block title="Buy with Confidence"></header-block>
      <div class="imageContainer">
        <v-img :src="require('@/assets/bg/BuyWithConfidence.png')" class="main-image" position="top" />
      </div>
      <div class="textContainer">
        <h2 class="title">Buy with confidence</h2>
        <v-img class="paymentMethods mb-4" :src="require('@/assets/payment-methods.png')" />

        <p class="paragraph">
          Experience seamless transactions with our secure payment options. Your financial safety is our top priority.
        </p>
      </div>
      <div class="footerText anchor-bottom">
        <p>We never share any information with your employer, or a third party without your consent.</p>
      </div>
    </div>
</template>

<script>
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
  name: 'BuyWithConfidencePage',
  components: {
    HeaderBlock
  }
};
</script>

<style scoped>

.imageContainer {
    /* margin: -20px -30px 0px -30px; */
    margin-left: -30px;
    margin-right: -30px;
    background-size: cover;
    margin-top: -20px;
    /* padding-top: 155px; */
}

.textContainer {
  padding: 40px 20px;
  margin-left: -30px;
  margin-right: -30px;
  text-align: center;
}

.paymentMethods {
  position: relative;
  width: 200px;
  margin: 20px auto 0 auto;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.footerText {
  padding: 40px 20px;
  text-align: center;
}

.footerText p {
  font-size: 11px;
}
</style>
